import * as React from "react";
import { IconButton, Tooltip, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useNotify } from "react-admin";
import { httpClient } from "../api/httpClient";
import { API_BASE_URL } from "../api/config";

// Bouton qui récupère l'URL présignée d'un document et l'ouvre dans un onglet.
// Backend : GET /documents/{id}/download-url → String (URL signée S3/R2).
export const DocumentDownloadButton = ({ documentId, label = "Télécharger" }) => {
  const notify = useNotify();
  const [loading, setLoading] = React.useState(false);
  if (!documentId) return null;
  const download = async (e) => {
    e?.stopPropagation?.();
    setLoading(true);
    try {
      const { json, body } = await httpClient(
        `${API_BASE_URL}/documents/${encodeURIComponent(documentId)}/download-url`
      );
      // Le backend renvoie l'URL en texte brut (ou { url }). Réponse vide =
      // document sans fichier stocké ; une valeur qui n'est pas une URL
      // http(s) (ancienne clé de stockage brute) n'est pas ouvrable.
      const raw = (typeof json === "string" && json) || json?.url || body || "";
      const url = String(raw).trim().replace(/^"|"$/g, "");
      if (/^https?:\/\//i.test(url)) {
        window.open(url, "_blank", "noopener,noreferrer");
      } else if (!url) {
        notify("Aucun fichier stocké pour ce document", { type: "warning" });
      } else {
        notify(`Lien de téléchargement indisponible (clé de stockage : ${url})`, { type: "error" });
      }
    } catch (err) {
      notify(
        err?.status === 403
          ? "Accès refusé : compte non administrateur (ADMIN_EMAILS)"
          : `Erreur : ${err.message}`,
        { type: "error" }
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Tooltip title={label}>
      <span>
        <IconButton size="small" onClick={download} disabled={loading} color="primary">
          {loading ? <CircularProgress size={16} /> : <DownloadIcon fontSize="small" />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default DocumentDownloadButton;
